module.exports = "thead th {\n  cursor: pointer; }\n  thead th .sort-arrow {\n    visibility: hidden;\n    margin-left: 1rem; }\n  thead th.active .sort-arrow {\n    visibility: visible; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/bill/payment-log/payment-log.component.scss
// module id = ./src/app/bill/payment-log/payment-log.component.scss
// module chunks = main